import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import AppLogo from "@/components/AppLogo";

const COMPANY = {
  razon_social: "A.E.I. Marketing y Negocios Tecnológicos, S.L.",
  cif: "B72939903",
  direccion: "C/ María Fernández \"La Perrata\", 12, 41740 Lebrija (Sevilla)",
  email: "abraham.herrera@tpvplus.es",
  telefono: "602 217 976",
  web: "entradasdeportivas.es",
};

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="flex items-center justify-between mb-8">
          <Link
            to="/login"
            data-testid="back-to-login-link"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-slate-600 hover:text-[#2563EB] transition"
          >
            <ArrowLeft size={16} weight="bold" /> Volver
          </Link>
          <AppLogo size={56} rounded={false} />
        </div>

        <article
          data-testid="aviso-legal-content"
          className="bg-white border border-slate-200 rounded-xl shadow-lg p-8 sm:p-10 space-y-6 text-slate-700 leading-relaxed"
        >
          <header>
            <h1 className="font-display font-bold text-3xl sm:text-4xl uppercase tracking-tighter text-slate-900">
              Aviso Legal
            </h1>
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-slate-400 mt-1">
              Información en cumplimiento de la LSSI-CE (Ley 34/2002)
            </p>
          </header>

          <Section title="1. Datos identificativos del titular">
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Razón social:</strong> {COMPANY.razon_social}</li>
              <li><strong>CIF:</strong> {COMPANY.cif}</li>
              <li><strong>Domicilio social:</strong> {COMPANY.direccion}</li>
              <li><strong>Correo electrónico:</strong> <a className="text-[#2563EB] hover:underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              <li><strong>Teléfono:</strong> {COMPANY.telefono}</li>
              <li><strong>Sitio web:</strong> {COMPANY.web}</li>
            </ul>
          </Section>

          <Section title="2. Objeto y ámbito de aplicación">
            <p>
              El presente Aviso Legal regula el uso del sitio web y de la aplicación
              <em> Entradasdeportivas</em> (en adelante, la "Plataforma"), titularidad de {COMPANY.razon_social}.
              El acceso y navegación por la Plataforma implican la aceptación sin reservas de las presentes condiciones.
            </p>
          </Section>

          <Section title="3. Condiciones de uso">
            <p>
              El usuario se compromete a hacer un uso adecuado y lícito de la Plataforma,
              de conformidad con la legislación aplicable, el presente Aviso Legal, la
              moral y las buenas costumbres. Queda prohibido cualquier uso que pueda
              perjudicar el correcto funcionamiento del sistema o los derechos de terceros.
            </p>
          </Section>

          <Section title="4. Propiedad intelectual e industrial">
            <p>
              Todos los contenidos de la Plataforma (textos, imágenes, código, marcas y logotipos)
              son propiedad de {COMPANY.razon_social} o de terceros que han autorizado su uso.
              Queda prohibida su reproducción, distribución o modificación sin autorización expresa.
            </p>
          </Section>

          <Section title="5. Responsabilidad">
            <p>
              {COMPANY.razon_social} no garantiza la disponibilidad ininterrumpida del servicio
              y no será responsable de los daños derivados de la interrupción, retraso o falta de disponibilidad,
              ni de los provocados por virus u otros elementos lesivos ajenos a su voluntad.
            </p>
          </Section>

          <Section title="6. Legislación aplicable y jurisdicción">
            <p>
              El presente Aviso Legal se rige por la legislación española.
              Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales
              del domicilio del titular, salvo que la normativa aplicable disponga otra jurisdicción imperativa.
            </p>
          </Section>

          <Section title="7. Modificaciones">
            <p>
              {COMPANY.razon_social} se reserva el derecho a modificar el presente Aviso Legal en
              cualquier momento. Las modificaciones serán efectivas desde su publicación en la Plataforma.
            </p>
          </Section>

          <footer className="pt-4 border-t border-slate-200 text-xs text-slate-500">
            Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" })}
          </footer>
        </article>

        <div className="text-center mt-6 text-xs text-slate-500">
          © {new Date().getFullYear()} {COMPANY.razon_social}. Todos los derechos reservados.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-lg uppercase tracking-tight text-slate-900 mb-2">{title}</h2>
      <div className="text-sm text-slate-700 space-y-2">{children}</div>
    </section>
  );
}
